import RenameModal from '../../../../components/rename-modal'
import { useHistory, useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useState } from 'react'
import { planMenuApiErrorCodeOptions } from '../../constants'
import { useSnackbar } from '../../../../components/stories/molecules/snackbar/component/snackbar-hook'
import { snackbarVariantOptions } from '../../../../components/stories/molecules/snackbar/constants'
import { useGetPlanFolderDetailsQuery } from '../../../../react-query/plan/query/use-get-plan-folder-details-query'
import { useUpdatePlanFolderDetailsMutation } from '../../../../react-query/plan/mutation/use-update-plan-folder-details-mutation'
import { useDispatch } from 'react-redux'
import { getRootPlansWithFolders } from '../../../PlanSelection/actions'
import { usePlanMenuListViewControl } from '../../../../hooks/use-plan-menu-list-view-control'

const PlanFoldersRenameModalWrapper = () => {
  const { formatMessage } = useIntl()
  const { addSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const { viewType } = usePlanMenuListViewControl()

  const [titleHintMessage, setTitleHintMessage] = useState(null)

  const history = useHistory()
  const { id, projectId } = useParams()

  const { data, isLoading } = useGetPlanFolderDetailsQuery(id)
  const getPlanTree = () => dispatch(getRootPlansWithFolders(projectId))

  const showSnackbarSuccess = () => {
    addSnackbar({
      message: formatMessage({ id: 'folder_renamed' }),
      snackbarType: snackbarVariantOptions.SUCCESS,
      hideCloseButton: true
    })
  }

  const handleClosePopup = () => {
    history.push(`/project/${projectId}?view=${viewType}`)
  }

  const handleUpdatePlanFolderDetailsSuccess = () => {
    getPlanTree()
    showSnackbarSuccess()
    handleClosePopup()
  }

  const handleUpdatePlanFolderDetailsError = (error) => {
    if (
      error &&
      error.response?.data?.status ===
        planMenuApiErrorCodeOptions.FOLDER_NAME_IS_NOT_AVAILABLE
    ) {
      setTitleHintMessage(
        formatMessage({ id: 'projectMenu_folder_with_this_name_aready_exists' })
      )
    }
  }

  const { mutate, isPending } = useUpdatePlanFolderDetailsMutation({
    onSuccess: handleUpdatePlanFolderDetailsSuccess,
    onError: handleUpdatePlanFolderDetailsError
  })

  const isLoadingModal = isPending || isLoading

  const handleUpdate = (name) => {
    setTitleHintMessage(null)
    mutate({
      folderId: id,
      folderDetails: { name }
    })
  }

  const oldName = data?.name ?? ''

  return (
    <RenameModal
      headerTitle={formatMessage(
        { id: 'projects_renameFolder' },
        { name: null }
      )}
      handleRename={handleUpdate}
      onClose={handleClosePopup}
      error={titleHintMessage}
      isLoading={isLoadingModal}
      oldName={oldName}
      isOpen
    />
  )
}

export default PlanFoldersRenameModalWrapper
